import { WIDGET_SHADOW_ROOT_ENABLED_DATA_ATTR } from "@/constants";
import { REWARDS_WIDGET_NAMES } from "@/constants/widget-names";
import { RewardsAvailableRewardsCartWidgetDefinition } from "@apps/rewards/constants/definitions";
import { RewardsWidgetInjectorConfig } from "@apps/rewards/types";
import WidgetInjectedSdkEvent from "@modules/sdk/common_sdk/events/WidgetInjectedSdkEvent";
import { dispatchSdkEvent } from "@modules/sdk/helpers";
import { parseOptionalBooleanDataAttr } from "@ui-utils/Injector/utils";

class AvailableRewardsCartWidgetInjector {
    constructor(private readonly config: RewardsWidgetInjectorConfig) {}

    start(): void {
        this.config.logger.debug("AvailableRewardsCartWidgetInjector start", {
            placeholderSelector: this.config.placeholderSelector,
        });
        const { REWARDS_AVAILABLE_REWARDS_CART_WIDGET } = REWARDS_WIDGET_NAMES;

        this.config.mutationObserverInjector
            .register({
                targetSelector: this.config.placeholderSelector,
            })
            .subscribe((placeholder) => {
                this.config.logger.debug(
                    "AvailableRewardsCartWidgetInjector found placeholder",
                    { placeholder }
                );

                void (async () => {
                    const AvailableRewardsCartWidget =
                        await this.config.dynamicImportManager.importDefault(
                            RewardsAvailableRewardsCartWidgetDefinition,
                            true
                        );

                    const widget = new AvailableRewardsCartWidget(
                        {
                            target: placeholder,
                            isWidgetShadowRootEnabled:
                                parseOptionalBooleanDataAttr(
                                    placeholder,
                                    WIDGET_SHADOW_ROOT_ENABLED_DATA_ATTR
                                ),
                        },
                        this.config.logger
                    );

                    await widget.init();

                    this.config.eventsCollector.pushEvent(
                        this.config.eventsFactory.createWidgetInjected(
                            REWARDS_AVAILABLE_REWARDS_CART_WIDGET
                        )
                    );

                    dispatchSdkEvent(
                        new WidgetInjectedSdkEvent(
                            REWARDS_AVAILABLE_REWARDS_CART_WIDGET
                        )
                    );
                })();
            });
    }
}

export default AvailableRewardsCartWidgetInjector;
